<template>
  <section class="internal-redirect">
    <WParagraph>
      {{ message.content }}
      <WLink
        class="internal-redirect__button"
        size="small"
        @click="handleClick"
      >
        {{ message.linkText }}
      </WLink>
    </WParagraph>
  </section>
</template>

<script>
import { WLink, WParagraph } from '@alice-health/wonderland-vue'

export default {
  components: { WParagraph, WLink },
  props: {
    message: { type: Object, required: true }
  },
  emits: ['internalRedirect'],
  methods: {
    handleClick() {
      this.$emit('internalRedirect', this.message.redirectTo)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';

.internal-redirect {
  &__button {
    @extend %reset-button;
    color: var(--gl-color-shades-magenta-60);
    display: inline-block;
    text-decoration: underline;

    &:hover {
      background-color: transparent;
    }

    &:after {
      content: none;
    }
  }
}
</style>
